import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map'; 
import {Observable} from 'rxjs/Rx';

import { AngularFireAuth } from 'angularfire2/auth';
import { HttpClient,HttpHeaders  } from '@angular/common/http';
import * as firebase from 'firebase/app';
import { FRdv } from '../model/FRdv';
import { FCreneaux } from '../model/FCreneaux';
import { FDemandeCreneaux } from '../model/FDemandeCreneaux';
import { WeekCreneauxLibre } from '../model/WeekCreneauxLibre';
@Injectable({
  providedIn: 'root'
})
export class RdvService {


  //private api = 'http://localhost:8080/FlandresServices/';  
  private api = 'https://www.apps.jdagency.fr/FlandresServices/';  
  private params = new URLSearchParams();  
  public listRdvTemp:FRdv[] = new Array<FRdv>();
  public listRdv:FRdv[] = new Array<FRdv>();

  public listCreneauxTemp:WeekCreneauxLibre[] = new Array<WeekCreneauxLibre>();
  public listCreneaux:WeekCreneauxLibre[] = new Array<WeekCreneauxLibre>();
 
  constructor(private http: HttpClient,private _firebaseAuth: AngularFireAuth) { 
    this.params.set('format', 'json');  
    this.params.set('callback', 'JSONP_CALLBACK'); 
  }

  getRdv(idToken, idFirebaseUser:string, idSite:number):Observable<FRdv[]>{
    const httpOptions = {
      headers: new HttpHeaders({
        'X-Firebase-Auth':  idToken
      })
    };
    const endPoint = 'rdv/list/' + idFirebaseUser + "/" + idSite;  
    // Returns response  
    return this.http.get(
                this.api + endPoint,
                httpOptions)
                .map(res => this.extractRdv(res))
                .catch((error:any) => Observable.throw('Server error'  || error ));
            
  }
  extractRdv(response)
  {
    this.listRdvTemp = [];
    this.listRdv = [];
    this.listRdvTemp=<FRdv[]>response;
  
    for (var _i = 0; _i < this.listRdvTemp.length; _i++) {
      //console.log("s" +JSON.stringify(response));
        this.listRdv[_i] = FRdv.fromJson(this.listRdvTemp[_i]);
    }
    return this.listRdv;
  }



  getCreneauxLibre(idToken, idFirebaseUser:string, FDemandeCreneaux:FDemandeCreneaux ):Observable<WeekCreneauxLibre[]>{
    const httpOptions = {
      headers: new HttpHeaders({
        'X-Firebase-Auth':  idToken
      })
    };
    const endPoint = 'rdv/creneaux/' + idFirebaseUser;  
    // Returns response  
    let body = JSON.stringify(FDemandeCreneaux);
    console.log(FDemandeCreneaux.dateDebut);
    return this.http.post(
                this.api + endPoint, FDemandeCreneaux,
                httpOptions)
                .map(res => this.extractCreneaux(res))
                .catch((error:any) => Observable.throw('Server error'  || error ));
            
  }
  extractCreneaux(response)
  {
    this.listCreneauxTemp = [];
    this.listCreneaux = [];
    this.listCreneauxTemp=<WeekCreneauxLibre[]>response;
  
    for (var _i = 0; _i < this.listCreneauxTemp.length; _i++) {
      //console.log("s" +JSON.stringify(response));
        this.listCreneaux[_i] = WeekCreneauxLibre.fromJson(this.listCreneauxTemp[_i]);
    }
    return this.listCreneaux;
  }

  setRdv(idToken, idFirebase:String, rdv:FRdv){
    const httpOptions = {
      headers: new HttpHeaders({
        'X-Firebase-Auth':  idToken
      })
    };
    const endPoint = 'rdv/add/' + idFirebase;
    console.log(this.api + endPoint)
    let body = JSON.stringify(rdv);
    // Returns response  
    this.http.post(
      this.api + endPoint, rdv,
      httpOptions)
      .catch((error:any) => Observable.throw('Server error'  || error ))
      .subscribe((result=>console.log(result)));
  }


  deleteRdv(idToken, idFirebase:String,idRdv:Number):Observable<Boolean>{
    const httpOptions = {
      headers: new HttpHeaders({
        'X-Firebase-Auth':  idToken
      })
    };
    const endPoint = 'rdv/delete/' + idFirebase + "/" + idRdv;
    console.log(this.api + endPoint)

    
    return this.http.post(
      this.api + endPoint, "",
      httpOptions)
      .map(res => true)
      .catch((error:any) => Observable.throw('Server error'  || error ));

  }


  lockCreneau(idToken, idFirebase:String,idCreneau: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'X-Firebase-Auth':  idToken
      })
    };
    const endPoint = 'rdv/creneaux/lock/' + idFirebase + "/" + idCreneau;
    console.log(this.api + endPoint)

    
    return this.http.get(
      this.api + endPoint,
      httpOptions)
      .catch((error:any) => Observable.throw('Server error'  || error ));

  }



  unlockCreneau(idToken, idFirebase:String,idCreneau: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'X-Firebase-Auth':  idToken
      })
    };
    const endPoint = 'rdv/creneaux/unlock/' + idFirebase + "/" + idCreneau;
    console.log(this.api + endPoint)

    
    return this.http.get(
      this.api + endPoint, httpOptions)
      .catch((error:any) => Observable.throw('Server error'  || error ));

  }


}
